import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { trackReports } from '../../../../core/constants/constants';
import {
  TrackMXVareQResponse,
} from '../../../../core/interface/mx-reports';
import { VarianceReportData } from '../../../../core/interface/export-reports';

@Component({
  standalone: false,
  selector: 'app-track-mx-vareq',
  templateUrl: './track-mx-vareq.component.html',
  styleUrl: './track-mx-vareq.component.less',
})
export class TrackMxVareqComponent implements OnInit, OnChanges {
  trackReport = trackReports;
  @Input() trackMXVareQResponse!: TrackMXVareQResponse[];
  @Input()
  reportData!: VarianceReportData;
  totalTrackSum: number = 0;
  totalMaxSum: number = 0;
  totalVarSum: number = 0;
  companyName: string = '';

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['trackMXVareQResponse'].currentValue != null) {
      this.calculateSum();
      this.companyName = this.trackMXVareQResponse[0].companyName;
    }
  }

  calculateSum() {
    this.totalTrackSum = 0;
    this.totalMaxSum = 0;
    this.totalVarSum = 0;
    this.trackMXVareQResponse.forEach((response) => {
      this.totalTrackSum += response.sumTrackHrs;
      this.totalMaxSum += response.sumMaxHrs;
      this.totalVarSum += response.sumVarHrs;
    });
  }
}
